var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVector5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 694,
    height: 719,
    viewBox: "0 0 694 719",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_1649_33391)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 74.2931,
    cy: 65.3382,
    rx: 74.2931,
    ry: 65.3382,
    transform: "matrix(-0.313322 0.949647 -0.905202 -0.424981 429.333 316.422)",
    fill: "#0094FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_1649_33391",
    x: 0.256683,
    y: 0.288666,
    width: 693.309,
    height: 717.836,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 141.539,
    result: "effect1_foregroundBlur_1649_33391"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector5);
export default __webpack_public_path__ + "static/media/vector5.38f82423198cc5ae823f59463cfba56c.svg";
export { ForwardRef as ReactComponent };